const mapDataObject = ({ dataObject }) => {
  const objectKeys = Object.keys(dataObject);

  return objectKeys.map(key => {
    return { key, value: dataObject[key] };
  });
};

export default mapDataObject;
